var _path, _rect, _path2, _rect2, _rect3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMyCart = function SvgMyCart(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "outline",
    viewBox: "0 0 512 512",
    width: 512,
    height: 512,
    fill: "#454545",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80,496H432a7.99977,7.99977,0,0,0,8-8V200a7.99977,7.99977,0,0,0-8-8H333.406l29.34448-34.84668-12.23828-10.30664L312.48853,192H293.40607L390.11914,77.15332a7.99965,7.99965,0,0,0-.4624-10.81006l-48-48A7.99877,7.99877,0,0,0,336,16H176a7.99877,7.99877,0,0,0-5.65674,2.34326l-48,48,.01361.01361a7.93132,7.93132,0,0,0-.476,10.79645L218.59393,192H199.51147l-38.02368-45.15332-12.23828,10.30664L178.594,192H80a7.99977,7.99977,0,0,0-8,8V488A7.99977,7.99977,0,0,0,80,496Zm48-44.68652L156.68652,480h-57.373ZM424,480H184V208H424ZM325.31177,80h41.4928l-82.985,98.54443Zm5.78753-16,8.39679-25.19037L364.68616,64Zm-15.17889-5.05957L279.99976,32H324.9007ZM296.00024,64H215.99976L256,34Zm-99.92065-5.05957L187.0993,32h44.90094ZM180.9007,64H147.31348l25.19043-25.19043ZM307.95142,80,260.7937,192h-9.58716L204.04865,80ZM186.68823,80l41.4925,98.54468L145.1958,80ZM120,208v88h16V208h32V468.68652l-32-32V344H120v92.68652l-32,32V208Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 312,
    width: 16,
    height: 16
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M259.05591,248l35.90014,71.80078a43.77693,43.77693,0,1,0,78.31055-39.15527L356.944,248H368V232H328v16h11.05591l19.90014,39.80078a27.77725,27.77725,0,0,1-49.68945,24.84473L276.944,248H288V232H248v16Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 366.26723,
    y: 119.75028,
    width: 21.571,
    height: 15.99944,
    transform: "translate(36.46369 333.876) rotate(-49.89951)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 126.94754,
    y: 116.9645,
    width: 15.99944,
    height: 21.571,
    transform: "matrix(0.76492, -0.64413, 0.64413, 0.76492, -50.56362, 116.95467)"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMyCart, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/my-cart.51c40415.svg";
export { ForwardRef as ReactComponent };